import React from "react";
import { ClipLoader } from "react-spinners";

function AdminPageShell({ title, subtitle, action, isLoading, children }) {
  return (
    <div>
      <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
        <div className="min-w-0">
          <h1 className="font-logo text-3xl text-black sm:text-4xl leading-tight">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-2 max-w-2xl font-josefin text-sm leading-relaxed text-textMuted">
              {subtitle}
            </p>
          )}
        </div>
        {action && <div className="shrink-0">{action}</div>}
      </div>

      <div className="overflow-hidden rounded-2xl border border-greyLight/30 bg-white shadow-sm">
        {isLoading ? (
          <div className="flex items-center justify-center py-20">
            <ClipLoader color="#84a59d" size={40} />
          </div>
        ) : (
          children
        )}
      </div>
    </div>
  );
}

export default AdminPageShell;
